<div class="components-wrapper" *ngIf="showForm || filtersActive">
  <div class="p-4">
    <form class="row" #tempFilterTabla="ngForm" (submit)="onSearchClicked()">
      <div class="col-md-12" *ngIf="showForm">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="selectedProperty">Propiedad: </label>
              <ng-select
                [items]="filterProperties"
                bindLabel="text"
                [(ngModel)]="selectedProperty"
                (change)="onPropertyChanged()"
                name="selectedProperty"
              ></ng-select>
            </div>
          </div>

          <!-- NOMBRE -->
          <div class="col-md-8" *ngIf="selectedProperty?.value === 'nombres'">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="nombres">Nombres:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="nombres"
                    #nombres="ngModel"
                    [(ngModel)]="tempFilter.nombres"
                    [class.is-invalid]="nombres.invalid && filterAttempted"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="apellidos">Apellidos:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="apellidos"
                    #apellidos="ngModel"
                    [(ngModel)]="tempFilter.apellidos"
                    [class.is-invalid]="apellidos.invalid && filterAttempted"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- RANGO DE FECHA -->
          <div class="col-md-8" *ngIf="selectedProperty?.value === 'desde'">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="desde">Desde:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="desde"
                    [(ngModel)]="tempFilter.desde"
                    #desde="ngModel"
                    [class.is-invalid]="desde.invalid && filterAttempted"
                    [bsConfig]="bsConfig"
                    bsDatepicker
                    autocomplete="off"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="hasta">Hasta:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="desde"
                    [(ngModel)]="tempFilter.hasta"
                    #hasta="ngModel"
                    [class.is-invalid]="hasta.invalid && filterAttempted"
                    [bsConfig]="bsConfig"
                    bsDatepicker
                    autocomplete="off"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- CODIGO -->
          <div class="col-md-4" *ngIf="selectedProperty?.value === 'identificacion'">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="identificacion">Identificación:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="identificacion"
                    #identificacion="ngModel"
                    [(ngModel)]="tempFilter.identificacion"
                    [class.is-invalid]="identificacion.invalid && filterAttempted"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- EMPRESA -->
          <div class="col-md-8" *ngIf="selectedProperty?.value === 'empresa'">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="empresa">Empresa:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="empresa"
                    #empresa="ngModel"
                    [(ngModel)]="tempFilter.empresa"
                    [class.is-invalid]="empresa.invalid && filterAttempted"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- ESTADO -->
          <div class="col-md-4" *ngIf="selectedProperty?.value === 'activo'">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="activo">Activo:</label>
                  <select
                    class="form-control"
                    name="activo"
                    #activo="ngModel"
                    [(ngModel)]="tempFilter.activo"
                    [class.is-invalid]="activo.invalid && filterAttempted"
                    required
                  >
                    <option [ngValue]="true">Activo</option>
                    <option [ngValue]="false">Desactivado</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- PERFIL -->
          <div class="col-md-4" *ngIf="selectedProperty?.value === 'perfil' && !hideProfile">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="perfil">Perfil:</label>
                  <ng-select
                    [items]="perfiles"
                    name="perfil"
                    bindLabel="nombre"
                    #perfil="ngModel"
                    [(ngModel)]="tempFilter.perfil"
                    [class.is-invalid]="perfil.invalid && filterAttempted"
                    required
                  >
                  </ng-select>
                </div>
              </div>
            </div>
          </div>

          <!-- ROL -->
          <div class="col-md-4" *ngIf="selectedProperty?.value === 'rol'">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="rol">Rol:</label>
                  <ng-select
                    name="rol"
                    [items]="roles"
                    bindLabel="nombre"
                    #rol="ngModel"
                    [(ngModel)]="tempFilter.rol"
                    [class.is-invalid]="rol.invalid && filterAttempted"
                    required
                  >
                  </ng-select>
                </div>
              </div>
            </div>
          </div>

          <!-- USERCODE -->
          <div class="col-md-4" *ngIf="selectedProperty?.value === 'userCode'">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="userCode">Codigo de usuario:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="userCode"
                    #userCode="ngModel"
                    [(ngModel)]="tempFilter.userCode"
                    [class.is-invalid]="userCode.invalid && filterAttempted"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-1">
            <button type="button" class="btn btn-secondary btn-square align-to-fields" (click)="onFilterAdded()">
              <i-feather name="plus"></i-feather>
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row clear-margin">
          <div class="filtering-label" *ngIf="saveFilter.nombres || saveFilter.apellidos">
            Nombre: {{ saveFilter.nombres }} {{ saveFilter.apellidos }}
            <button type="button" (click)="onFilterRemoved('nombres', 'apellidos')">
              <i-feather name="x-circle"></i-feather>
            </button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.desde || saveFilter.hasta">
            Fecha: {{ saveFilter.desde | date : "d/MM/yyyy" }} - {{ saveFilter.hasta | date : "d/MM/yyyy" }}
            <button type="button" (click)="onFilterRemoved('desde', 'hasta')"><i-feather name="x-circle"></i-feather></button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.identificacion">
            Identificación: {{ saveFilter.identificacion }}
            <button type="button" (click)="onFilterRemoved('identificacion')"><i-feather name="x-circle"></i-feather></button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.empresa">
            Empresa: {{ saveFilter.empresa }}
            <button type="button" (click)="onFilterRemoved('empresa')"><i-feather name="x-circle"></i-feather></button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.activo === true || saveFilter.activo === false">
            Estado: {{ saveFilter.activo ? "Activo" : "Desactivado" }}
            <button type="button" (click)="onFilterRemoved('activo')"><i-feather name="x-circle"></i-feather></button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.perfil">
            Perfil: {{ saveFilter.perfil.nombre }}
            <button type="button" (click)="onFilterRemoved('perfil')"><i-feather name="x-circle"></i-feather></button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.rol">
            Rol: {{ saveFilter.rol.nombre }}
            <button type="button" (click)="onFilterRemoved('rol')"><i-feather name="x-circle"></i-feather></button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.userCode">
            Código de usuario: {{ saveFilter.userCode }}
            <button type="button" (click)="onFilterRemoved('userCode')"><i-feather name="x-circle"></i-feather></button>
          </div>

          <div class="col-md-12 p-0" *ngIf="showForm">
            <button type="submit" uni-button>Buscar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
